import { useProNavigate } from '@mp/contexts';
import { useNetworkRequest } from '@mp/hooks/useNetworkRequest';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useApplicationMutations = () => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const { navigate } = useProNavigate();

  const { mutate: nextStep, isPending: nextLoading } = useMutation(
    () => axios.patch(`/v3/professional/application_wizard/next`),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ['currentUser'] });
        await queryClient.invalidateQueries({ queryKey: ['GetCurrentUserForAccountInfoStep'] });
        await queryClient.invalidateQueries({ queryKey: ['GetCurrentUserForMarketsStep'] });
        navigate('Application');
      },
    },
  );

  const { mutate: nextStepWithValues, isPending: nextWithValuesLoading } = useMutation(
    (values: unknown) => axios.patch(`/v3/professional/application_wizard/next`, values),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ['currentUser'] });
        await queryClient.invalidateQueries({ queryKey: ['GetCurrentUserForAccountInfoStep'] });
        await queryClient.invalidateQueries({ queryKey: ['GetCurrentUserForMarketsStep'] });
        navigate('Application');
      },
    },
  );

  const { mutate: prevStep, isPending: prevLoading } = useMutation(
    () => {
      return axios.patch(`/v3/professional/application_wizard/back`);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ['currentUser'] });
        navigate('Application');
      },
    },
  );

  return {
    nextStep,
    nextStepWithValues,
    prevStep,
    isLoading: nextLoading || prevLoading || nextWithValuesLoading,
  };
};
